<script setup>
import { ref, nextTick, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { Toast } from 'bootstrap';
import { useToastStore } from '../stores/toast-store';

/**
 * Toasts
 */
const { hide: toastHide } = useToastStore();

/**
 * Users
 * Loading
 * Error
 */
const {
  open: toastOpen,
  type: toastType,
  message: toastMessage,
} = storeToRefs(useToastStore());

/**
 * Toast template ref
 */
const toastRef = ref(null);

/**
 * Boostrap toast
 */
let toast = null;

const show = async () => {
  // Wait for rerender
  await nextTick();

  toast = new Toast(toastRef.value);
  toast.show();

  toastRef.value.addEventListener('hidden.bs.toast', () => {
    toastHide();
  });
};

const hide = () => {
  toast.hide();
};

watch(
  () => toastOpen.value,
  (value) => {
    value === true ? show() : hide();
  },
);
</script>

<template>
  <div
    v-if="toastOpen"
    class="toast-container position-fixed bottom-0 start-50 translate-middle-x p-3 mb-3"
  >
    <div
      ref="toastRef"
      class="toast align-items-center border-0"
      :class="toastType"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="d-flex">
        <div class="toast-body text-white">
          {{ toastMessage }}
        </div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          data-bs-dismiss="toast"
          aria-label="Close"
        ></button>
      </div>
    </div>
  </div>
</template>
